import React from 'react';

const ImageTextSection = ({ image, imageAlt = '', title, children, imageAction }) => {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image */}
        <div className="flex flex-col items-center mb-8 md:mb-12">
          <div className="w-full max-w-2xl">
            {image ? (
              <img
                src={image}
                alt={imageAlt}
                className="w-full rounded-lg shadow-lg"
              />
            ) : (
              <div className="w-full h-64 md:h-96 bg-gray-200 rounded-lg flex items-center justify-center">
                <span className="text-gray-500">Image placeholder</span>
              </div>
            )}
            {imageAction && (
              <div className="flex justify-end mt-2">
                {imageAction}
              </div>
            )}
          </div>
        </div>

        {/* Text Content */}
        <div className="max-w-3xl mx-auto">
          {title && (
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6 font-PlusJakartaSans">
              {title}
            </h2>
          )}
          {children && (
            <div className="text-base md:text-lg text-gray-600 leading-relaxed font-Inter">
              {children}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ImageTextSection;
